import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

import { useIsMobile } from '../../hooks/useIsMobile';

interface PhoneBrowseRedirectProps {
  show: 'stays' | 'services';
  children: React.ReactNode;
}

/**
 * On a phone, a list page opened with no query string is the Discover view of
 * the same section; with a query string (search results, a type grid) it stays
 * on its own address. Desktop never redirects.
 */
const PhoneBrowseRedirect: React.FC<PhoneBrowseRedirectProps> = ({ show, children }) => {
  const isPhone = useIsMobile();
  const { search } = useLocation();

  if (isPhone && !search) return <Navigate to={`/discover?show=${show}`} replace />;
  return <>{children}</>;
};

export default PhoneBrowseRedirect;
